var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarSchedule = function SvgCalendarSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeWidth: 2,
    clipPath: "url(#calendar-schedule_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29 5H3a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M1 13h30M9 8V1M23 8V1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19a.5.5 0 0 1 0-1M7.5 19a.5.5 0 0 0 0-1M7.5 26a.5.5 0 0 1 0-1M7.5 26a.5.5 0 0 0 0-1M16 19a.5.5 0 0 1 0-1M16 19a.5.5 0 0 0 0-1M16 26a.5.5 0 0 1 0-1M16 26a.5.5 0 0 0 0-1M24.5 19a.5.5 0 0 1 0-1M24.5 19a.5.5 0 0 0 0-1M24.5 26a.5.5 0 0 1 0-1M24.5 26a.5.5 0 0 0 0-1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-schedule_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCalendarSchedule;